import { FC } from 'react';
import { Contaienr, GroupButtonSkeleton, TitleSkeleton, Wrapper } from './GroupTrend.style';
const GroupTrendSkeleton: FC = () => {
  return <Contaienr>
            <TitleSkeleton shape="round" />
            <Wrapper>
                <GroupButtonSkeleton active />
                <GroupButtonSkeleton active />
                <GroupButtonSkeleton active />
                <GroupButtonSkeleton active />
                <GroupButtonSkeleton active />
            </Wrapper>
            <Wrapper>
                <GroupButtonSkeleton active />
                <GroupButtonSkeleton active />
                <GroupButtonSkeleton active />
                <GroupButtonSkeleton active />
            </Wrapper>
            <Wrapper>
                <GroupButtonSkeleton active />
                <GroupButtonSkeleton active />
                <GroupButtonSkeleton active />
                <GroupButtonSkeleton active />
                <GroupButtonSkeleton active />
            </Wrapper>
        </Contaienr>;
};
export default GroupTrendSkeleton;